import { render } from "./CommonAgentAccountOption.vue?vue&type=template&id=1ec89018&scoped=true&ts=true"
import script from "./CommonAgentAccountOption.vue?vue&type=script&lang=ts"
export * from "./CommonAgentAccountOption.vue?vue&type=script&lang=ts"

import "./CommonAgentAccountOption.vue?vue&type=style&index=0&id=1ec89018&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec89018"]])

export default __exports__